<div class="enrolment-form">
  <div #errorMessage>
    <lx-error-message *ngIf="form?.invalid && submitted"></lx-error-message>
  </div>
  <form #formContainer (ngSubmit)="onSubmit()" [formGroup]="form" lxFormErrorTracker [currentStep]="currentStep$ | async">
    <h3 class="enrolment-form__title enrolment-form__student-details" i18n>Student details</h3>
    <lx-form-field-lite [control]="form.controls.title" data-qa="enrolmentForm_title" i18n-label label="Title">
      <div class="enrolment-form__title-control">
        <div *ngFor="let option of titleOptions">
          <p-radioButton [inputId]="option.code" [value]="option.code" formControlName="title" (onBlur)="form.controls.title.markAsTouched()" name="title">
          </p-radioButton>

          <label [for]="option.code">
            {{ option.name }}
          </label>
        </div>
      </div>
    </lx-form-field-lite>
    <div class="enrolment-form__full-name">
      <lx-form-field-lite [control]="form.controls.firstName" i18n-label label="First Name">
        <input [attr.autocomplete]="'given-name'" data-qa="enrolmentForm_inputFirstName" formControlName="firstName" pInputText type="text" />
      </lx-form-field-lite>
      <lx-form-field-lite [control]="form.controls.lastName" i18n-label label="Last Name">
        <input [attr.autocomplete]="'family-name'" data-qa="enrolmentForm_inputLastName" formControlName="lastName" pInputText type="text" />
      </lx-form-field-lite>
    </div>
    <lx-form-field-lite [control]="form.controls.dateOfBirth" i18n-label label="Date of birth">
      <lx-date-of-birth-field data-qa="enrolmentForm_dateOfBirth" formControlName="dateOfBirth"></lx-date-of-birth-field>
    </lx-form-field-lite>
    <lx-form-field-lite [control]="form.controls.motherTongue" i18n-label label="Mother tongue">
      <lx-mother-tongue-selector
        i18n-title
        title="Mother tongue"
        formControlName="motherTongue"
        data-qa="enrolmentForm_motherTongue"
      ></lx-mother-tongue-selector>
    </lx-form-field-lite>
    <lx-form-field-lite [control]="form.controls.nationality" i18n-label label="Nationality">
      <lx-nationality-selector i18n-title title="Nationality" formControlName="nationality" data-qa="enrolmentForm_nationality"></lx-nationality-selector>
    </lx-form-field-lite>

    <lx-form-field-lite [control]="form.controls.email" i18n-label label="Email">
      <input [attr.autocomplete]="'email'" data-qa="enrolmentForm_inputEmail" formControlName="email" lxBlockSpaces pInputText type="email" />
    </lx-form-field-lite>

    <lx-form-field-lite [control]="form.controls.phoneNumber" i18n-label label="Phone">
      <lx-phone-number-field i18n-title title="Phone code" formControlName="phoneNumber" data-qa="enrolmentForm_phoneNumber"></lx-phone-number-field>
    </lx-form-field-lite>

    <div *ngIf="whatsappOptIn" class="enrolment-form__whatsapp-opt-in">
      <div class="enrolment-form__whatsapp-opt-in__checkbox">
        <p-checkbox [binary]="true" data-qa="enrolmentForm_whatsappOptIn" formControlName="whatsappOptIn"></p-checkbox>
      </div>
      <div class="enrolment-form__whatsapp-opt-in__text" i18n>Are you happy for us to respond to your inquiry via WhatsApp?</div>
    </div>
    <div class="enrolment-form__address-details">
      <lx-form-field-lite [control]="form.controls.address" i18n-label label="Address">
        <input
          [attr.autocomplete]="'address-line1'"
          data-qa="enrolmentForm_inputAddress"
          formControlName="address"
          i18n-placeholder
          pInputText
          placeholder="Address line 1 *"
          type="text"
        />
      </lx-form-field-lite>

      <lx-form-field-lite [control]="form.controls.address2">
        <input
          [attr.autocomplete]="'address-line2'"
          data-qa="enrolmentForm_inputAddress2"
          formControlName="address2"
          i18n-placeholder
          pInputText
          placeholder="Address line 2 (Optional)"
          type="text"
        />
      </lx-form-field-lite>

      <lx-form-field-lite [control]="form.controls.city">
        <lx-region-country-field
          [textInputMode]="countryRegionType !== CountryRegionType.CITY"
          i18n-title
          title="City / town"
          [regions]="regions"
          formControlName="city"
          i18n-placeholder
          placeholder="City / town *"
          data-qa="enrolmentForm_city"
        ></lx-region-country-field>
      </lx-form-field-lite>

      <lx-form-field-lite [control]="form.controls.regionStateProvince">
        <lx-region-country-field
          [textInputMode]="countryRegionType !== CountryRegionType.STATE"
          i18n-title
          title="State / Province / Region"
          [regions]="regions"
          formControlName="regionStateProvince"
          data-qa="enrolmentForm_state"
          [placeholder]="regionFieldPlaceholder"
        ></lx-region-country-field>
      </lx-form-field-lite>

      <lx-form-field-lite [control]="form.controls.postcode">
        <input
          [attr.autocomplete]="'postal-code'"
          data-qa="enrolmentForm_postcode"
          formControlName="postcode"
          i18n-placeholder
          pInputText
          placeholder="Zip / postcode *"
          type="text"
        />
      </lx-form-field-lite>

      <lx-form-field-lite [control]="form.controls.countryOfResidence">
        <lx-residence-country-selector
          title="Country of residence"
          i18n-title
          formControlName="countryOfResidence"
          data-qa="enrolmentForm_countryOfResidence"
        ></lx-residence-country-selector>
      </lx-form-field-lite>

      <div *ngIf="priceConfirmation" class="enrolment-form__price-confirmation">
        <div i18n>Prices for {{ residenceCountry }} to be confirmed</div>
      </div>
    </div>
    <ng-container *ngIf="!onlineFlow">
      <h3 class="enrolment-form__title" i18n>Personal and Health Information</h3>
      <lx-form-field-lite
        [control]="form.controls.hasAllergiesConditionsOrTreatments"
        i18n-label
        label="Do you require a specific diet, have any allergies, medical conditions, regular medicine or treatments?"
      >
        <lx-yes-no-radio-button
          name="allergiesConditionsOrTreatments"
          data-qa="enrolmentForm_hasAllergiesConditionsOrTreatments"
          formControlName="hasAllergiesConditionsOrTreatments"
        ></lx-yes-no-radio-button>
      </lx-form-field-lite>

      <ng-container *ngIf="form.controls.hasAllergiesConditionsOrTreatments.value">
        <lx-form-field-lite
          [control]="form.controls.allergiesConditionsOrTreatments"
          i18n-label
          i18n-subLabel
          label="Please provide a description of your dietary requirements, allergies, medical conditions, regular medicine or treatments"
          subLabel="Please note special diet supplement might apply."
        >
          <textarea
            [autoResize]="false"
            data-qa="enrolmentForm_allergiesConditionsOrTreatments"
            formControlName="allergiesConditionsOrTreatments"
            pInputTextarea
            rows="5"
          ></textarea>
        </lx-form-field-lite>
      </ng-container>

      <lx-form-field-lite [control]="form.controls.specialRequests" i18n-label label="Special Request">
        <input
          data-qa="enrolmentForm_specialRequests"
          formControlName="specialRequests"
          i18n-placeholder
          pInputText
          placeholder="Please note some special requests might imply supplements"
          type="text"
        />
      </lx-form-field-lite>

      <ng-container *ngIf="activeFlow === Flows.Adult">
        <lx-form-field-lite
          [control]="form.controls.isAdult"
          i18n-label
          label="Will the participating student be over 18 upon arrival at the {{ company | lxCompanyFormattedName }} school?"
        >
          <lx-yes-no-radio-button data-qa="enrolmentForm_isAdult" formControlName="isAdult" name="isAdult"></lx-yes-no-radio-button>
        </lx-form-field-lite>
      </ng-container>

      <div *ngIf="form.controls.isAdult.value !== undefined" class="enrolment-form__contact-fields">
        <ng-container *ngTemplateOutlet="form.controls.isAdult.value ? emergencyContactFields : guardianFields"></ng-container>
      </div>

      <ng-template #guardianFields>
        <h3 class="enrolment-form__title" i18n>Guardian details</h3>
        <div class="enrolment-form__full-name">
          <lx-form-field-lite [control]="form.controls.guardianFirstName" i18n-label label="First Name">
            <input
              [attr.autocomplete]="'given-name'"
              data-qa="enrolmentForm_inputGuardianFirstName"
              formControlName="guardianFirstName"
              pInputText
              type="text"
            />
          </lx-form-field-lite>
          <lx-form-field-lite [control]="form.controls.guardianLastName" i18n-label label="Last Name">
            <input
              [attr.autocomplete]="'family-name'"
              data-qa="enrolmentForm_inputGuardianLastName"
              formControlName="guardianLastName"
              pInputText
              type="text"
            />
          </lx-form-field-lite>
        </div>
        <lx-form-field-lite [control]="form.controls.guardianEmail" i18n-label label="Email">
          <input
            [attr.autocomplete]="'email'"
            data-qa="enrolmentForm_inputGuardianEmail"
            formControlName="guardianEmail"
            lxBlockSpaces
            pInputText
            type="email"
          />
        </lx-form-field-lite>

        <lx-form-field-lite [control]="form.controls.guardianPhone" i18n-label label="Phone">
          <lx-phone-number-field i18n-title title="Phone code" data-qa="enrolmentForm_guardianPhone" formControlName="guardianPhone"></lx-phone-number-field>
        </lx-form-field-lite>
      </ng-template>
      <ng-template #emergencyContactFields>
        <h3 class="enrolment-form__title" i18n>Emergency details</h3>
        <div class="enrolment-form__full-name">
          <lx-form-field-lite [control]="form.controls.emergencyContactFirstName" i18n-label label="First Name">
            <input data-qa="enrolmentForm_inputEmergencyFirstName" formControlName="emergencyContactFirstName" pInputText type="text" />
          </lx-form-field-lite>
          <lx-form-field-lite [control]="form.controls.emergencyContactLastName" i18n-label label="Last Name">
            <input
              [attr.autocomplete]="'family-name'"
              data-qa="enrolmentForm_inputEmergencyLastName"
              formControlName="emergencyContactLastName"
              pInputText
              type="text"
            />
          </lx-form-field-lite>
        </div>
        <lx-form-field-lite [control]="form.controls.emergencyContactEmail" i18n-label label="Email">
          <input
            [attr.autocomplete]="'email'"
            data-qa="enrolmentForm_inputEmergencyEmail"
            lxBlockSpaces
            formControlName="emergencyContactEmail"
            pInputText
            type="email"
          />
        </lx-form-field-lite>

        <lx-form-field-lite [control]="form.controls.emergencyContactPhone" i18n-label label="Emergency contact phone">
          <lx-phone-number-field
            i18n-title
            title="Phone code"
            data-qa="enrolmentForm_emergencyContactPhone"
            formControlName="emergencyContactPhone"
          ></lx-phone-number-field>
        </lx-form-field-lite>
      </ng-template>
    </ng-container>

    <div class="enrolment-form__checkbox enrolment-form__checkbox--spaced">
      <p-checkbox [binary]="true" data-qa="enrolmentForm_termsAndConditionsConsent" formControlName="termsAndConditionsConsent"></p-checkbox>
      <div
        [class.enrolment-form__checkbox__label--error]="form.controls.termsAndConditionsConsent.invalid && form.controls.termsAndConditionsConsent.touched"
        class="enrolment-form__checkbox__label"
      >
        <span i18n> I completely agree with the terms and conditions of {{ company | lxCompanyFormattedName }}. </span>
        <span class="enrolment-form__checkbox__label__required">*</span>
        <a
          [class.enrolment-form__checkbox__label__link--error]="
            form.controls.termsAndConditionsConsent.invalid && form.controls.termsAndConditionsConsent.touched
          "
          [href]="termsAndConditionsLink"
          class="enrolment-form__checkbox__label__link"
          i18n
          target="_blank"
        >
          Terms and Conditions</a
        >
      </div>
    </div>

    <div *ngIf="!onlineFlow" class="enrolment-form__checkbox">
      <p-checkbox [binary]="true" data-qa="enrolmentForm_hasMedicalInsuranceProof" formControlName="hasMedicalInsuranceProof"></p-checkbox>
      <div
        [class.enrolment-form__checkbox__label--error]="form.controls.hasMedicalInsuranceProof.invalid && form.controls.hasMedicalInsuranceProof.touched"
        class="enrolment-form__checkbox__label"
      >
        <span i18n>
          I acknowledge that a proof of medical insurance will be required from me (either {{ company | lxCompanyFormattedName }}'s insurance provider or
          through a third party).
        </span>
        <span class="enrolment-form__checkbox__label__required">*</span>
      </div>
    </div>

    <div class="enrolment-form__checkbox">
      <p-checkbox [binary]="true" data-qa="enrolmentForm_optOutMarketing" formControlName="optOutMarketing"></p-checkbox>
      <div class="enrolment-form__checkbox__label" i18n>
        We'd like to keep in touch to share the latest news and special offers from the Kaplan Languages Group. If this isn't for you, tick the box to opt out.
      </div>
    </div>

    <div class="enrolment-form__privacy-policy" i18n>
      {{ company | lxCompanyFormattedName }} is committed to respecting and preserving your privacy.
      <a [href]="privacyPolicyLink" target="_blank" class="enrolment-form__privacy-policy__link">More Info</a>
    </div>

    <lx-acquisition-disclaimer></lx-acquisition-disclaimer>

    <div class="enrolment-form__footer">
      <lx-button
        (buttonClick)="backToQuote()"
        [block]="true"
        [btnRounded]="true"
        buttonStyle="quaternary"
        class="enrolment-form__footer__back"
        data-qa="enrolmentForm_backToQuote"
        i18n-text
        id="btn-back"
        text="Back to quote"
      >
      </lx-button>
      <lx-button
        [class.enrolment-form__footer__pay--adult]="activeFlow !== Flows.Junior"
        [class.enrolment-form__footer__pay--junior]="activeFlow === Flows.Junior"
        (buttonClick)="onSubmit()"
        [block]="true"
        [btnRounded]="true"
        buttonStyle="primary"
        class="enrolment-form__footer__pay"
        data-qa="enrolmentForm_payNow"
        i18n-text
        id="btn-pay"
        text="Enrol"
      >
      </lx-button>
    </div>
  </form>
</div>
